import React, { useState } from "react";
import { useAppSelector } from '../app/hooks';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  Typography,
  AppBar,
  Toolbar,
  Container,
  Button,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import LogoutIcon from "@mui/icons-material/Logout";
import authService from "../services/AuthService";
import { ADMIN_APP_NAME, REACT_APP_LOGIN_URL } from "../constants";
import {
  AccountCircle,
  KeyboardArrowDown,
  ManageAccounts,
  NavigateBefore,
} from "@mui/icons-material";
import { Menu as MenuIcon } from "@mui/icons-material";
import Navdrawer from "./NavDrawer";
import { UserDisplayName } from "../functions";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const currentUser = useAppSelector(s => s.currentUser);

  const menuClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  return (
    <React.Fragment>
      <AppBar
        variant="elevation"
        position="fixed"
        color="primary"
        component="nav"
        sx={{ zIndex: 1300 }}
      >
        <Toolbar
          sx={{ px: 0, "@media (min-width:600px)": { px: 0 } }}
          id="topnav"
        >
          <Container maxWidth="xl">
            <Box pl={2} pr={3} display="flex" alignItems="center">
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={() => setDrawerOpen((o) => !o)}
                sx={{ mr: 2, ml: 0 }}
              >
                {drawerOpen ? <NavigateBefore /> : <MenuIcon />}
              </IconButton>
              <Box
                component="img"
                src={`${window.location.origin}/admin-logo-white.png`}
                m={1}
                maxWidth={150}
              />
              <Box flexGrow={1} />
              <Box mr={1}>
                {currentUser && (
                  <Button
                    sx={{ textTransform: "none", p: 0 }}
                    onClick={(event) => {
                      setAnchorEl(event.currentTarget);
                      setMenuOpen(true);
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <KeyboardArrowDown sx={{ color: "#fff" }} />
                      <Box px={1}>
                        <Typography variant="h6" color="white">
                          {UserDisplayName(currentUser.data)}
                        </Typography>
                      </Box>
                      <AccountCircle sx={{ ml: 1, color: "#fff" }} />
                    </Box>
                  </Button>
                )}
              </Box>
            </Box>
          </Container>
        </Toolbar>
      </AppBar>

      <Menu open={menuOpen} anchorEl={anchorEl} onClose={menuClose}>
        <MenuItem
          onClick={() => {
            menuClose();
            window.open(`${REACT_APP_LOGIN_URL}/account`, "_blank");
          }}
        >
          <ListItemIcon>
            <ManageAccounts />
          </ListItemIcon>
          <Typography variant="body2">My Account</Typography>
        </MenuItem>
        <MenuItem
          onClick={async () => {
            menuClose();
            await authService.logout();
          }}
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <Typography variant="body2">Log Out</Typography>
        </MenuItem>
        {currentUser.data?.applications && currentUser.data.applications.length > 1 && <Divider />}
        {(currentUser.data?.applications ?? [])
          .filter((a) => a.clientId !== ADMIN_APP_NAME)
          .map((application, i) => (
            <MenuItem
              onClick={() => {
                menuClose();
                window.open(`${application.clientUri}`, "_blank");
              }}
              key={i}
            >
              <ListItemIcon>
                <OpenInNewIcon />
              </ListItemIcon>
              <Typography variant="body2">{application.clientName}</Typography>
            </MenuItem>
          ))}
      </Menu>
      <Navdrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </React.Fragment>
  );
}
